import React from "react";
import styled from "styled-components";

const StyledSideNav = styled.div`
  margin-top: 0px;
  top: 32px;
  list-style: none;
  ul {
    margin: 0;
    padding: 0;
    padding-right: 24px;
    /* list-items  */
    li {
      margin: 8px 0;
      list-style: none;
      font-size: 0.8rem;
    }
    /* sub-lists  */
    ul {
      margin: 0;
      padding-left: 16px;
      /* sub-list-items  */
      li {
        margin: 8px 0;
        padding: 4px 8px;
      }
    }
    /* links */
    a {
      color: ${({ theme }) => theme.colors.gray1200};
      text-decoration: none;
    }
  }
`;

const NavListStyleWrapper = ({ children, className }) => {
  return <StyledSideNav className={className}>{children}</StyledSideNav>;
};

export default NavListStyleWrapper;
